import Icon from './Icon';
import LeadForm from './LeadForm';
import { HERO_POINTS, TRUST_ITEMS } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__blob hero__blob--a" aria-hidden="true" />
      <div className="hero__blob hero__blob--b" aria-hidden="true" />
      <div className="shell hero__inner">
        <div className="hero__copy">
          <p className="hero__pill">
            <i aria-hidden="true" />
            Experts online now — call{' '}
            <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
          </p>
          <h1>
            Accounting software errors? <em>Let the experts fix them.</em>
          </h1>
          <p className="hero__lede">
            From company files that refuse to open to bank feeds that never reconcile, our
            certified bookkeeping experts find the cause fast — and agree a fixed price with you
            before any repair starts.
          </p>

          <div className="hero__actions">
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
              <Icon name="phone" size={18} />
              Call {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              <Icon name="chat" size={18} />
              Chat with an expert
            </button>
          </div>

          <ul className="hero__points">
            {HERO_POINTS.map((point) => (
              <li key={point}>
                <Icon name="check" size={16} />
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="hero__form">
          <LeadForm
            variant="compact"
            title="Get a free error check"
            subtitle="Tell us what went wrong — an expert replies the same working day."
            cta="Check my error for free"
            formName="hero"
          />
        </div>
      </div>

      <div className="shell">
        <ul className="trust">
          {TRUST_ITEMS.map((item) => (
            <li key={item.label}>
              <span className="trust__icon">
                <Icon name={item.icon} size={18} />
              </span>
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
